module.exports = __webpack_public_path__ + "assets/images/badge-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/badge-on.png
// module id = 1486
// module chunks = 1